<template>
  <div>
    <el-row>
      <el-form :inline="true" class="demo-form-inline" style="margin-top: 20px" :model="searchForm" @submit.native.prevent>
        <el-form-item label="产品名称：">
          <el-input size="medium" v-model="searchForm.productName" placeholder="请输入产品名称"
            @keyup.enter.native="() => { if (searchForm.productName) { handleSearch() } }" clearable></el-input>
        </el-form-item>
        <el-button size="medium" type="primary" @click="handleSearch">筛选</el-button>
        <el-button size="medium" @click="batchSelect">批量添加</el-button>
        <el-badge :value="selectedTableData.length" class="item" :hidden="selectedTableData.length == 0">
          <el-button size="medium" @click="() => { selectedProductsVisible = true }">已选产品</el-button>
        </el-badge>
      </el-form>
    </el-row>
    <el-row>
      <el-col>
        <el-table border stripe :data="queryTableData" ref="queryTableData" @selection-change="handleSelectionChange" max-height="520"
          row-key="INNER_CODE">
          <el-table-column type="selection" width="50" :selectable="(row) => { return !row.isSelected }" :reserve-selection="true">
          </el-table-column>
          <el-table-column label="产品编码" prop="INNER_CODE"></el-table-column>
          <el-table-column label="产品名称" prop="NAME"></el-table-column>
          <el-table-column label="单位" prop="TYPE_UNIT"></el-table-column>
          <el-table-column label="操作" width="100px">
            <template slot-scope="scope">
              <el-button size="small" type="text" @click="selectProduct(scope.row)" icon="el-icon-check" v-if="!scope.row.isSelected">
                添加
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-drawer title="已选产品" :visible.sync="selectedProductsVisible" size="50%" class="spec-drawer">
          <el-table border stripe :data="selectedTableData" style="margin: 5px;">
            <el-table-column label="序号" type="index" width="50"></el-table-column>
            <el-table-column label="产品编码" prop="INNER_CODE"></el-table-column>
            <el-table-column label="产品名称" prop="NAME"></el-table-column>
            <el-table-column label="单位" prop="TYPE_UNIT" width="100px"></el-table-column>
            <el-table-column label="单价" prop="CURRENT_PRICE">
              <template slot-scope="scope">
                <el-input v-model="scope.row.CURRENT_PRICE" @change="checkInputtedPrice(scope.row)" clearable>
                </el-input>
              </template>
            </el-table-column>
            <el-table-column label="订购数量" prop="PRODUCT_COUNT">
              <template slot-scope="scope">
                <el-input v-model="scope.row.PRODUCT_COUNT" @change="checkInputtedCount(scope.row)" clearable>
                </el-input>
              </template>
            </el-table-column>
            <el-table-column label="总金额" prop="PRODUCT_FEE">
              <template slot-scope="scope">
                <el-input v-model="scope.row.PRODUCT_FEE" @change="checkInputtedTotal(scope.row)"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="70px">
              <template slot-scope="scope">
                <el-button size="small" type="text" @click="deleteProduct(scope.row)" style="color:#F56C6C">
                  删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-button size="small" @click="finishEntry()" :disabled="finishDisabled" style="margin: 5px;">
            完成添加
          </el-button>
        </el-drawer>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { addOrderListFun } from 'api/shopOrderManage';
import { getActionFun } from 'api/login';
import http from '@/assets/common/http';
import validation from '@/assets/common/validation';

export default {
  data() {
    return {
      // PAGE_ID: '1010001', // 页面ID 一旦规定不要轻易改动
      // fun_dic: { 101000101: 0 },
      searchForm: {},
      queryTableData: [],
      selectedTableData: [],
      checkedArray: [],
      selectedProductsVisible: false,
      priceReg: /(^([1-9]\d*)(.\d{1,2})?$)|(^(0{1})(.\d{1,2}){1}$)/,
      countReg: /(^([1-9]\d*)(.\d{1,3})?$)|(^(0{1})(.\d{1,3}){1}$)/,
      currentPage: 0,
      // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
      pageSize: Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 10,
      currentTop: 0,
      totalCount: 0,
      lastName: '',
      loading: false,
    };
  },
  computed: {
    finishDisabled() {
      for (const item of this.selectedTableData) {
        if (!(this.checkCount(item.PRODUCT_COUNT, item.TYPE_UNIT) && this.checkPrice(item.CURRENT_PRICE)) || !(item.PRODUCT_COUNT > 0 && item.CURRENT_PRICE > 0)) {
          return true;
        }
      }
      return false;
    },
    isUndone() {
      return this.queryTableData.length < this.totalCount;
    },
  },
  watch: {
    selectedTableData() {
      this.queryTableData = this.queryTableData.map((item1) => ({
        ...item1, isSelected: Boolean(this.selectedTableData.find((item2) => item1.INNER_CODE == item2.INNER_CODE)),
      }));
    },
  },
  beforeRouteLeave(to, from, next) {
    if (this.selectedTableData.length) {
      this.$confirm('正在离开本页面，未添加至订单的已选产品数据将会丢失，确定要离开吗？', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        next();
      }).catch((err) => {
        // eslint-disable-next-line no-console
        console.log(err);
      });
    } else {
      next();
    }
  },
  created() {
    this.handleSearch();
  },
  mounted() {
    this.scrollLoading();
  },
  methods: {
    // 控制功能按钮
    async queryBeforeFun() {
      const params = {
        PAGE_ID: this.PAGE_ID,
      };
      await getActionFun(params).then((result) => {
        if (result.length !== 0) {
          this.forMenu(result, this.fun_dic);
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    forMenu(e) {
      const tmp_fun_list = e;
      for (let i = 0; i < tmp_fun_list.length; i++) {
        for (const key in this.fun_dic) {
          if (tmp_fun_list[i].FUNCTION_NUM == key) {
            this.fun_dic[key] = 1;
          }
        }
      }
    },

    async handleSearch() {
      if (this.searchForm.productName != this.lastName) {
        this.currentPage = 0;
        this.currentTop = 0;
      }
      const data = {
        SERVICE_ID: '10008',
        OTYPE: 54,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
        SUPPLIER_ID: Number(sessionStorage.getItem('supplierId')),
        PROJECT_ID: Number(sessionStorage.getItem('projectId')),
        ORDER_ID: Number(this.$route.params.orderId),
        SEND_DAY: sessionStorage.getItem('SEND_DAY'),
        PRODUCT_NAME: this.searchForm.productName,
        PAGEINDEX: this.currentPage,
        PAGESIZE: this.pageSize,
      };
      await http.post(data).then((res) => {
        this.totalCount = res[0].TOTAL_COUNT;
        if (this.searchForm.productName !== this.lastName) {
          this.queryTableData = res[0].list.map((item1) => ({
            ...item1, isSelected: Boolean(this.selectedTableData.find((item2) => item1.INNER_CODE == item2.INNER_CODE)),
          }));
        } else {
          this.queryTableData.push(...res[0].list.map((item1) => ({
            ...item1, isSelected: Boolean(this.selectedTableData.find((item2) => item1.INNER_CODE == item2.INNER_CODE)),
          })));
          this.queryTableData = this.queryTableData.slice(0, this.totalCount);
        }
        this.lastName = this.searchForm.productName;
        this.$forceUpdate();
        this.loading = false;
      }).catch((err) => {
        this.$message.show({ text: err, type: 'error' });
      });
    },
    selectProduct(row) {
      this.selectedTableData.push({ ...row, PRODUCT_FEE: row.CURRENT_PRICE * row.PRODUCT_COUNT });
    },
    batchSelect() {
      // this.selectedTableData.push(...this.checkedArray);
      this.checkedArray.forEach((item) => {
        this.selectProduct(item);
      });
      this.$refs.queryTableData.clearSelection();
    },
    handleSelectionChange(val) {
      this.checkedArray = val;
    },
    deleteProduct(row) {
      this.selectedTableData = this.selectedTableData.filter((item) => item.INNER_CODE != row.INNER_CODE);
    },
    checkInputtedPrice(row) {
      if (!this.checkPrice(row.CURRENT_PRICE)) {
        this.$message.show({ text: '请输入正确的价格', type: 'warning' });
        return;
      }
      this.countTotal(row);
    },
    checkPrice(price) {
      // return this.priceReg.test(price);
      return validation.价格正数验证(price);
    },
    checkInputtedCount(row) {
      if (!this.checkCount(row.PRODUCT_COUNT, row.TYPE_UNIT)) {
        this.$message.show({ text: this.$util.JudgmentUnit(row.TYPE_UNIT) ? '请输入正确的数量' : '单位非公斤、斤的产品数量须为整数', type: 'warning' });
        return;
      }
      this.countChange(row);
    },
    checkCount(count, typeUnit) {
      return this.countReg.test(count) ? (this.$util.JudgmentUnit(typeUnit) ? true : !(Number(count) % 1)) : false;
    },
    checkInputtedTotal(row) {
      if (!this.checkPrice(row.PRODUCT_FEE)) {
        this.$message.show({ text: '请输入正确的价格', type: 'warning' });
        return;
      }
      this.countPrice(row);
    },
    // 将选择的商品添加到订单，完成后返回手动录入页面
    async finishEntry() {
      const paramsList = [];
      const resList = [];
      const erroeList = [];
      let flag = 0;
      this.selectedTableData.forEach((item, index) => {
        paramsList.push({
          ORDER_ID: Number(sessionStorage.getItem('orderId')),
          SUPPLIER_ID: Number(sessionStorage.getItem('supplierId')),
          PRODUCT_COUNT: Number(item.PRODUCT_COUNT),
          PRICE: Number(item.CURRENT_PRICE),
          PRODUCT_CODE: item.INNER_CODE,
          PRODUCT_FEE: item.PRODUCT_FEE,
          // PRODUCT_FEE: Number(Math.round((item.CURRENT_PRICE * item.PRODUCT_COUNT) * 100) / 100),
        });
      });
      for (const item of paramsList) {
        try {
          // eslint-disable-next-line no-await-in-loop
          const res = await addOrderListFun(item);
          resList.push(res);
        } catch (e) {
          erroeList.push(e);
        }
      }
      if (erroeList.length !== 0) {
        flag = 2;
      }
      if (flag == 0) {
        this.$message.show({ text: '成功批量添加产品到订单', type: 'success' });
        this.selectedTableData = [];
        this.$router.push({ path: '/s_addOrder/detail' });
      } else {
        let errText = '';
        let newArr = new Set(erroeList);
        newArr = Array.from(newArr);
        for (const item of newArr) {
          errText = `${item},${errText}`;
        }
        this.$message.show({ text: errText, type: 'error' });
      }
    },
    countChange(row) {
      if (row.CURRENT_PRICE != '') {
        this.countTotal(row);
      } else if (row.PRODUCT_FEE != '') {
        this.countPrice(row);
      }
    },
    countTotal(row) {
      if (row.CURRENT_PRICE != '' && row.PRODUCT_COUNT != '') {
        row.PRODUCT_FEE = Math.round((row.CURRENT_PRICE * row.PRODUCT_COUNT) * 100) / 100;
      }
    },
    countPrice(row) {
      if (row.PRODUCT_COUNT != 0) {
        row.CURRENT_PRICE = Math.round((row.PRODUCT_FEE / row.PRODUCT_COUNT) * 100) / 100;
      }
    },
    scrollLoading() {
      this.$nextTick(async () => {
        const PRODUCTS_VIEW = this.$refs.queryTableData.bodyWrapper;
        await PRODUCTS_VIEW.addEventListener('scroll', async () => {
          const SCROLL_TOP = PRODUCTS_VIEW.scrollTop;
          const SCROLL_HEIGHT = PRODUCTS_VIEW.scrollHeight;
          const CLIENT_HEIGHT = PRODUCTS_VIEW.clientHeight;
          if (SCROLL_TOP > 0 && (SCROLL_TOP + CLIENT_HEIGHT >= SCROLL_HEIGHT - 1) && SCROLL_TOP > this.currentTop && this.isUndone && !this.loading) {
            this.loading = true;
            this.currentPage++;
            await this.handleSearch();
            this.currentTop = SCROLL_TOP;
          }
        });
      });
    },
  },
};
</script>
<style scoped>
.spec-drawer /deep/ .el-drawer__body {
  padding: 3px 30px;
  overflow-y: auto;
  height: calc(100vh - 140px);
}

/* div>>>::-webkit-scrollbar {
  width: 0;
  display: none
} */
</style>



// WEBPACK FOOTER //
// src/components/shopOrderManage/s_batchAddOrder.vue